import {performHttpRequest} from "../http";
import {transform} from "ol/proj";

import {getLatLonProjectionName, getViewProjectionName, isBelgium} from "@/helpers/ol/ol-projection-helper";

export async function searchLocation(q, searchType = 0) {
    const center = transform(window.view.getCenter(), getViewProjectionName(), getLatLonProjectionName())
    const cbsCodes = window.settings.DefaultGemeente
    const provinceCodes = window.settings.DefaultProvince

    let country = ''
    if(isBelgium()) {
        country = '&country=be'
    }

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/routeapi/location/lng/' + center[0] + '/lat/' + center[1] + '?pvCodes=' + provinceCodes + '&cbsCodes=' + cbsCodes + '&query=' + q + '&searchType=' + searchType + country,
        'GET',
    )
}

export async function getLocationById(q) {

    let country = ''
    if(isBelgium()) {
        country = '?country=be&q=' + q
        q = ''
    }



    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/routeapi/location/lookup/' + q + country,
        'GET',
    )
}

export async function getLocationByLngLat(lng, lat) {

    let country = '?country=nl'
    if(isBelgium()) {
        country = '?country=be'
    }

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/routeapi/location/lng/' + lng + '/lat/' + lat + '/reversed' + country,
        'GET',
    )
}

export async function getLocationByAddress(address) {
    const data = {}
    data.q = address
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/routeapi/location/encode',
        'POST',
        data
    )
}
